<nb-user (click)="uploader.click()" size="giant" [name]="userModel?.userName"
    [picture]="pictureHeadShot||currentPicture" onlyPicture id="nb-user-headshot">
</nb-user>
<input type="file" accept="image/*" hidden #uploader (change)="fileChangeEvent($event)">